import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import { animateElements, createStoryPanel, destroyInstructions, displayTutorialHand, playUISound } from "../helpers/levelManager"
import { displayInstructions } from "../helpers/levelManager"

export default class StoryIntroScene extends Phaser.Scene {
	constructor() {
		super({ key: "StoryIntroScene" })
		this.currentPage = 0
		this.totalPages = 3
		this.pageIndicators = []
		this.storyContent = []
	}

	init() {
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		// Get scaling information
		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.designWidth = scalingData.designWidth
		this.designHeight = scalingData.designHeight

		// UI container reference
		this.uiContainer = null

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		// Standard button sizing and spacing
		this.buttonWidth = 50
		this.buttonHeight = 50

		// Reset to first page when scene initializes
		this.currentPage = 0

		// Define story content for each page
		this.storyTitles = ["[b]Welcome to C.A.R.E.[/b]", "", ""]

		this.storyExplanations = [
			"[b]The Cosmic Alliance for Recovery & Exploration.[/b]\n\nCongratulations, Medinaut! You’ve officially been recruited to the galaxy’s most heartwarming team of health and science officers known as C.A.R.E. — the Cosmic Alliance for Recovery & Exploration.\n\n[b]Our mission? To bring care, curiosity, and compassion to the farthest corners of the galaxy.[/b]",
			"Reports are coming in from distant planets—mysterious creatures are in need of help. Your mission, should you choose to accept it (and you kind of already have), includes:\n\n[b]  • Travelling[/b] to remote planets\n[b]  • Rescuing and scanning[/b] mysterious alien species\n[b]  • Logging[/b] your findings in the official Creature Database\n[b]  • Discovering[/b] what each creature eats and feeding them accordingly\n[b]  • Caring[/b] for them until they’re ready to be returned home",
			"But don’t forget — [b]your spaceship only launches when you've earned enough Fuel XP by completing important systems checks and solving mission puzzles.[/b] These tests will prepare you for using all kinds of tech and tools. Once your fuel tank is full, it’s liftoff time to the next planet!\n\nNow suit up! Customise your gear, prep your dashboard, and let’s bring healing to the stars.\n\n[b]C.A.R.E. is proud to have you aboard. This mission is going to be out of this world![/b]",
		]

		this.congratsPhrases = ['GOOD JOB!', 'WELL DONE!', 'GREAT!', 'AWESOME!'];
		this.lastCongratsPhrase = null;

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor
	}

	/**
	 * Creates the scene's content, including the background, story panel, and buttons.
	 */
	create() {
		this.createBackground()
		this.soundManager = this.scene.get("GameUI").soundManager
		//this.createStoryBackground()

		// this.storyPanel = createStoryPanel(this, {
		// 	xScale: 1,
		// 	yScale: 1.2,
		// 	titles: this.storyTitles,
		// 	content: this.storyExplanations,
		// 	nextSceneKey: "Customization",
		// 	buttonWidth: this.buttonWidth,
		// 	buttonHeight: this.buttonHeight,
		// 	fontSize: this.fontSize,
		// 	finalButtonText: "LET'S GO!",
		// 	indicatorYOffset: 250,
		// 	yOffset: 80,
		// 	titleXPos: 250,
		// 	titleYPos: 100,
		// 	titleFontScale: 5,
		// 	contentFontScale: -6,
		// 	contentYOffset: -10,
		// 	wrapWidth: 0.6,
		// 	indicator: true,
		// })

		// this.tutorialStep06()
		// return
		this.welcomeMedinaut = this.add.image(this.gameW / 2, this.gameH / 2, 'welcomeMedinaut').setScale(this.scaleFactor * 0.5)

		this.startTutorialButton = this.add.image(this.gameW / 2, this.gameH / 2, 'tutorialBtn').setVisible(false).setAlpha(0).setInteractive().setScale(this.scaleFactor * 0.5)
		this.startTutorialButton.on('pointerdown', () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.tutorialStep01()
			this.startTutorialButton.setVisible(false)
		})

		this.time.delayedCall(3000, () => {
			this.tweens.add({
				targets: this.welcomeMedinaut,
				alpha: 0,
				duration: 500,
				ease: 'Linear'
			})
			this.tweens.add({
				targets: this.startTutorialButton,
				alpha: 1,
				duration: 500,
				ease: 'Linear',
				delay: 500,
			})
			this.startTutorialButton.setVisible(true)

			displayInstructions(
				this,
				"Before your first mission, we need to test your skills.\nPress the button below to start the tutorial.",
				12,
				400,
				60,
			)
		})

		// Create overlay and text once
		// Create overlay div
		this.wellDoneOverlay = document.createElement('div');
		this.wellDoneOverlay.style.position = 'absolute';
		this.wellDoneOverlay.style.top = '0';
		this.wellDoneOverlay.style.left = '0';
		this.wellDoneOverlay.style.width = '100%';
		this.wellDoneOverlay.style.height = '100%';
		this.wellDoneOverlay.style.backgroundColor = 'rgba(17, 4, 78, 0.8)';
		this.wellDoneOverlay.style.transform = `translateX(100%)`;
		this.wellDoneOverlay.style.transition = 'transform 0.5s ease';
		this.wellDoneOverlay.style.zIndex = '100000'; // Adjust as needed
		this.wellDoneOverlay.style.pointerEvents = 'none';

		// Create text div
		this.wellDoneTextEl = document.createElement('div');
		this.wellDoneTextEl.textContent = 'WELL DONE!';
		this.wellDoneTextEl.style.position = 'absolute';
		this.wellDoneTextEl.style.top = '50%';
		this.wellDoneTextEl.style.left = '50%';
		this.wellDoneTextEl.style.transform = 'translate(-50%, -50%)';
		this.wellDoneTextEl.style.fontSize = Math.round(this.fontSize + 19 * this.scaleFactor) + 'px';
		this.wellDoneTextEl.style.color = '#fff';
		this.wellDoneTextEl.style.fontFamily = '"Gluten", sans-serif';
		this.wellDoneTextEl.style.fontWeight = '700';
		this.wellDoneTextEl.style.textAlign = 'center';
		this.wellDoneTextEl.style.zIndex = '100001'; // Above overlay
		this.wellDoneTextEl.style.pointerEvents = 'none';

		this.wellDoneOverlay.appendChild(this.wellDoneTextEl);
		document.body.appendChild(this.wellDoneOverlay);
		//this.tutorialStep01()
		// this.createPageIndicators();

		// this.firstContainer = this.add.container(0, 0);
		// this.secondContainer = this.add.container(0, 0);
		// this.thirdContainer = this.add.container(0, 0);

		// this.createWelcomeScreen();

		// // Forward button
		// this.nextButton = this.add.image(
		//     this.storyBG.x + this.storyBG.width / 2 * this.scaleFactor - 50 * this.scaleFactor,
		//     this.storyBG.y + 90 * this.scaleFactor,
		//     'forwardButton'
		// ).setScale(this.scaleFactor * 0.5)
		//     .setInteractive({ useHandCursor: true })
		//     .on('pointerdown', () => {
		//         console.log("Transitioning to next page");
		//         //this.showRatingScreen();
		//     });
	}

	tutorialStep01() {

		displayInstructions(
			this,
			"Press the box to tick it.",
			12,
			180,
			60,
		)

		// Inject CSS styles
		const styleId = 'tutorial-checkbox-styles';
		if (!document.getElementById(styleId)) {
			const style = document.createElement('style');
			style.id = styleId;
			style.textContent = `
            .tutorial-container {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                text-align: center;
                z-index: 1000;
            }

            .tutorial-instruction {
                background: white;
                color: #333;
                padding: 12px 24px;
                border-radius: 25px;
                margin-bottom: 40px;
                font-size: 16px;
                font-weight: 500;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
                font-family: Arial, sans-serif;
            }

			.tutorial-checkbox-wrapper {
				display: inline-block;
				position: relative;
			}

            .tutorial-checkbox-input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                width: 80px;
                height: 80px;
            }

            .tutorial-checkbox-custom {
                width: ${110 * this.scaleFactor}px;
                height: ${110 * this.scaleFactor}px;;
                background: #ffffff;
                border-radius: 16px;
                border: 3px solid rgba(255, 255, 255, 0.3);
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
                position: relative;
                pointer-events: none;
            }

			.tutorial-checkbox-custom::before {
				content: '';
				position: absolute;
				top: -3px;
				left: -3px;
				right: -3px;
				bottom: -3px;
				border-radius: 16px;
				background: linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.1));
				z-index: -1;
				opacity: 0;
				transition: opacity 0.3s ease;
			}

            .tutorial-checkmark {
                width: ${100 * this.scaleFactor}px;
                height: ${100 * this.scaleFactor}px;
                stroke: white;
                stroke-width: 7;
                stroke-linecap: round;
                stroke-linejoin: round;
                fill: none;
                opacity: 0;
                transform: scale(0);
                transition: all 0.3s ease;
            }

            .tutorial-checkbox-input:checked ~ .tutorial-checkbox-custom .tutorial-checkmark {
                opacity: 1;
                transform: scale(1);
                animation: tutorial-checkmark-pop 0.4s ease;
            }

            @keyframes tutorial-checkmark-pop {
                0% { transform: scale(0) rotate(-45deg); }
                50% { transform: scale(1.2) rotate(5deg); }
                100% { transform: scale(1) rotate(0deg); }
            }

            .tutorial-checkbox-input:checked ~ .tutorial-checkbox-custom {
                background: linear-gradient(135deg, #9333ea 0%, #6b21a8 100%);
                box-shadow: 0 8px 25px rgba(147, 51, 234, 0.6),
                            inset 0 2px 10px rgba(255, 255, 255, 0.3);
            }

            .tutorial-checkbox-wrapper:active .tutorial-checkbox-custom {
                transform: scale(0.95);
            }
        `;
			document.head.appendChild(style);
		}

		// Create container
		const container = document.createElement('div');
		container.className = 'tutorial-container';
		container.id = 'tutorial-step-01';

		// Create checkbox wrapper
		const checkboxWrapper = document.createElement('label');
		checkboxWrapper.className = 'tutorial-checkbox-wrapper';

		// Create checkbox input
		const checkbox = document.createElement('input');
		checkbox.type = 'checkbox';
		checkbox.className = 'tutorial-checkbox-input';
		checkbox.id = 'tutorial-checkbox';

		// Create custom checkbox div
		const customCheckbox = document.createElement('div');
		customCheckbox.className = 'tutorial-checkbox-custom';

		// Create SVG checkmark
		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.setAttribute('class', 'tutorial-checkmark');
		svg.setAttribute('viewBox', '0 0 52 52');

		const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
		polyline.setAttribute('points', '14 27 22 35 38 17');

		svg.appendChild(polyline);
		customCheckbox.appendChild(svg);

		// Assemble elements
		checkboxWrapper.appendChild(checkbox);
		checkboxWrapper.appendChild(customCheckbox);
		container.appendChild(checkboxWrapper);

		// Add to document
		document.body.appendChild(container);

		// Add event listener
		checkbox.addEventListener('change', (e) => {
			if (e.target.checked) {
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				console.log('Checkbox checked! Moving to next step...');

				//Add a small delay for visual feedback
				setTimeout(() => {
					// Clean up
					container.remove();

					// Call your next tutorial step here
					this.wellDoneAnimation(() => this.tutorialStep02());
				}, 500);
			}
		});

		// Optional: Return a cleanup function
		return () => {
			const element = document.getElementById('tutorial-step-01');
			if (element) element.remove();
		};
	}

	tutorialStep02() {
		displayInstructions(
			this,
			"Press the dropdown menu ‘arrow' button.",
			12,
			270,
			60,
		)

		const styleId = 'tutorial-dropdown-styles';

		// Remove existing styles if any
		const existingStyle = document.getElementById(styleId);
		if (existingStyle) {
			existingStyle.remove();
		}

		const thumbSVG = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 120'%3E%3Cdefs%3E%3ClinearGradient id='thumbGrad' x1='0%25' y1='0%25' x2='0%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%23e8e8ff;stop-opacity:1' /%3E%3Cstop offset='50%25' style='stop-color:%23a8a8ff;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%236868ff;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='80' height='120' rx='40' fill='url(%23thumbGrad)' stroke='%2311044E' stroke-width='3'/%3E%3Cellipse cx='40' cy='25' rx='25' ry='15' fill='%23d8d8ff' opacity='0.6'/%3E%3Crect x='25' y='45' width='30' height='3' rx='1.5' fill='%23ffffff' opacity='0.7'/%3E%3Crect x='25' y='52' width='30' height='3' rx='1.5' fill='%23ffffff' opacity='0.7'/%3E%3Ccircle cx='40' cy='95' r='20' fill='none' stroke='%235050dd' stroke-width='2' stroke-dasharray='3,3' opacity='0.5'/%3E%3C/svg%3E`;

		// Add custom styles for the dropdown
		const style = document.createElement('style');
		style.id = styleId;
		style.innerHTML = `
    #tutorial-dropdown-container {
        position: fixed;
        top: 0;
        left: 0;
        width: ${this.game.config.width}px;
        height: ${this.game.config.height}px;
        pointer-events: none;
        z-index: 1000;
    }
    
    .tutorial-dropdown {
        position: absolute;
        left: ${this.game.config.width / 2}px;
        top: ${this.game.config.height / 2}px;
        transform: translate(-50%, -50%) scale(${this.scaleFactor});
        transform-origin: center center;
        pointer-events: auto;
    }
    
    .dropdown-header {
        background: #E8EBFF;
        border: 3px solid #5C58EB;
        border-radius: 12px;
        padding: 12px 40px 12px 16px;
        min-width: 200px;
        min-height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        font-family: "Space Grotesk", sans-serif;
        font-weight: 700;
        color: #11044E;
        font-size: 16px;
        position: relative;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2311044E' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: right 12px center;
        background-size: 24px 24px;
    }
        
        .dropdown-header.open {
            background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2311044E' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M18 15l-6-6-6 6'/%3e%3c/svg%3e");
        }
        
        .dropdown-items {
            background: #E8EBFF;
            border: 3px solid #5C58EB;
            border-radius: 12px;
            margin-top: 8px;
            overflow: hidden;
            max-height: 0;
            opacity: 0;
            transition: max-height 0.3s ease, opacity 0.3s ease;
        }
        
        .dropdown-items.open {
            max-height: 200px;
            opacity: 1;
        }
        
        .dropdown-item {
            padding: 12px 16px;
            cursor: pointer;
            font-family: "Space Grotesk", sans-serif;
            font-weight: 600;
            color: #11044E;
            font-size: 16px;
            border-bottom: 2px solid #D0D5F5;
            text-align: center;
        }
        
        .dropdown-item:last-child {
            border-bottom: none;
        }
        
        .dropdown-item:hover {
            background: #D0D5F5;
        }
    `;
		document.head.appendChild(style);

		// Create or get the HTML container
		let htmlContainer = document.getElementById('tutorial-dropdown-container');
		if (!htmlContainer) {
			htmlContainer = document.createElement('div');
			htmlContainer.id = 'tutorial-dropdown-container';
			document.body.appendChild(htmlContainer);
		}

		// Sync function to match Phaser canvas transform
		const syncHTMLContainer = () => {
			const canvas = this.game.canvas;
			if (!htmlContainer || !canvas) return;

			// Get canvas dimensions
			const canvasRect = canvas.getBoundingClientRect();

			// Calculate scale the same way Phaser does
			const scaleX = canvasRect.width / this.game.config.width;
			const scaleY = canvasRect.height / this.game.config.height;
			const scale = Math.max(scaleX, scaleY);

			// Calculate the actual scaled dimensions
			const scaledWidth = this.game.config.width * scale;
			const scaledHeight = this.game.config.height * scale;

			// Calculate the offset to center the overflowing content
			const offsetX = (canvasRect.width - scaledWidth) / 2;
			const offsetY = (canvasRect.height - scaledHeight) / 2;

			// Position container to match canvas
			htmlContainer.style.position = 'fixed';
			htmlContainer.style.left = `${canvasRect.left}px`;
			htmlContainer.style.top = `${canvasRect.top}px`;
			htmlContainer.style.width = `${this.game.config.width}px`;
			htmlContainer.style.height = `${this.game.config.height}px`;

			// Apply scale and translate to center the content properly
			htmlContainer.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
			htmlContainer.style.transformOrigin = 'top left';
		};

		// Initial sync
		syncHTMLContainer();

		// Sync on resize
		const resizeHandler = () => syncHTMLContainer();
		window.addEventListener('resize', resizeHandler);

		// Create dropdown HTML
		const dropdownHTML = `
        <div class="tutorial-dropdown">
            <div class="dropdown-header" id="dropdown-header">
                <span id="dropdown-selected">Dropdown Menu</span>
            </div>
            <div class="dropdown-items" id="dropdown-items">
                <div class="dropdown-item" data-value="1">1</div>
                <div class="dropdown-item" data-value="2">2</div>
                <div class="dropdown-item" data-value="3">3</div>
            </div>
        </div>
    `;

		// Add dropdown to container
		htmlContainer.innerHTML = dropdownHTML;

		// Get elements
		const header = document.getElementById('dropdown-header');
		const items = document.getElementById('dropdown-items');
		const selected = document.getElementById('dropdown-selected');

		// Variables to hold tutorial elements
		let dropDownTutImage = null;

		// Toggle dropdown
		header.addEventListener('click', () => {
			items.classList.toggle('open');
			header.classList.toggle('open');
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			// Show tutorial elements when dropdown opens
			if (items.classList.contains('open')) {
				// Calculate position for the second dropdown item
				const secondItemY = this.gameH / 2;

				// Create dropDownTutImage
				dropDownTutImage = this.add.image(
					this.gameW / 2 + 280 * this.scaleFactor,
					this.gameH / 2 + 50 * this.scaleFactor,
					'dropDownTut'
				).setScale(this.scaleFactor / 2.4).setOrigin(0.5);

				animateElements([dropDownTutImage], this)

				// Display tutorial hand next to the second option
				displayTutorialHand(this, {
					xPos: 240 * this.scaleFactor,
					yPos: secondItemY,
					rotation: 90
				});
			} else {
				// Destroy tutorial elements when dropdown closes
				if (dropDownTutImage) {
					dropDownTutImage.destroy();
					dropDownTutImage = null;
				}
				if (this.tutorialHand) {
					this.tutorialHand.destroy();
				}
			}
		});

		// Handle item selection
		document.querySelectorAll('.dropdown-item').forEach(item => {
			item.addEventListener('click', (e) => {
				const value = e.target.getAttribute('data-value');
				selected.textContent = value;
				items.classList.remove('open');
				header.classList.remove('open');
				playUISound(this, this.soundManager, "Subtle click 1", 0.25)
				// Destroy tutorial elements
				if (dropDownTutImage) {
					dropDownTutImage.destroy();
					dropDownTutImage = null;
				}
				if (this.tutorialHand) {
					this.tutorialHand.destroy();
				}

				// Proceed to next tutorial step
				setTimeout(() => {
					this.cleanupDropdown(htmlContainer, styleId, resizeHandler);
					this.wellDoneAnimation(() => this.tutorialStep03());
				}, 500);
			});
		});

		// Store references for cleanup
		this.currentDropdown = htmlContainer;
		this.dropdownResizeHandler = resizeHandler;
	}

	cleanupDropdown(container, styleId, resizeHandler) {
		// Remove dropdown content
		if (container) {
			container.innerHTML = '';
		}

		// Remove styles
		const style = document.getElementById(styleId);
		if (style) {
			style.remove();
		}

		// Remove resize listener
		if (resizeHandler) {
			window.removeEventListener('resize', resizeHandler);
		}
	}
	tutorialStep03() {

		this.detailsTabActive = true
		this.activityTabActive = false

		displayInstructions(
			this,
			"Change to another tab by pressing ‘Tab 2’.",
			12,
			300,
			60,
		)

		this.tabHolder = this.add
			.image(this.gameW / 2, this.gameH / 2 - 60 * this.scaleFactor, "tabsHolder")
			.setScale(this.scaleFactor * 0.4, this.scaleFactor)
			.setOrigin(0.5)

		// Details tab (starts active)
		this.detailsTab = this.add
			.image(
				this.tabHolder.x / 2 + 155 * this.scaleFactor,
				this.tabHolder.y + 8 * this.scaleFactor,
				"tab1Active",
			)
			.setScale(this.scaleFactor * 0.3)
			.setInteractive()

		// Activity tab (starts inactive)
		this.activityTab = this.add
			.image(
				this.detailsTab.x + 75 * this.scaleFactor,
				this.tabHolder.y + 8 * this.scaleFactor,
				"tab2Inactive",
			)
			.setScale(this.scaleFactor * 0.3)
			.setInteractive()

		this.tabContent = this.add
			.image(this.tabHolder.x, this.tabHolder.y + 110 * this.scaleFactor, "tab1Contents")
			.setScale(this.scaleFactor * 0.31)

		// Tab interaction
		this.detailsTab.on("pointerdown", () => {
			if (this.detailsTabActive) return
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.detailsTabActive = true
			this.activityTabActive = false

			this.detailsTab.setTexture("tab1Active")
			this.activityTab.setTexture("tab2Inactive")
			this.tabContent.setTexture("tab1Contents")
		})

		this.activityTab.on("pointerdown", () => {
			if (this.activityTabActive) return
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.activityTabActive = true
			this.detailsTabActive = false

			this.activityTab.setTexture("tab2Active")
			this.detailsTab.setTexture("tab1Inactive")
			this.tabContent.setTexture("tab2Contents")

			setTimeout(() => {
				this.detailsTab.destroy()
				this.activityTab.destroy()
				this.tabContent.destroy()
				this.tabHolder.destroy()
				this.wellDoneAnimation(() => this.tutorialStep04());
			}, 500);
		})
	}

	tutorialStep04() {
		displayInstructions(
			this,
			"This is a scrollbar.",
			12,
			250,
			60,
		)

		const styleId = 'tutorial-scrollbar-styles';

		// Remove existing styles if any
		const existingStyle = document.getElementById(styleId);
		if (existingStyle) {
			existingStyle.remove();
		}

		// Create or get the HTML container
		let htmlContainer = document.getElementById('tutorial-scrollbar-container');
		if (!htmlContainer) {
			htmlContainer = document.createElement('div');
			htmlContainer.id = 'tutorial-scrollbar-container';
			document.body.appendChild(htmlContainer);
		}

		// Sync function to match Phaser canvas transform
		const syncHTMLContainer = () => {
			const canvas = this.game.canvas;
			if (!htmlContainer || !canvas) return;

			const canvasRect = canvas.getBoundingClientRect();
			const scaleX = canvasRect.width / this.game.config.width;
			const scaleY = canvasRect.height / this.game.config.height;
			const scale = Math.max(scaleX, scaleY);

			const scaledWidth = this.game.config.width * scale;
			const scaledHeight = this.game.config.height * scale;
			const offsetX = (canvasRect.width - scaledWidth) / 2;
			const offsetY = (canvasRect.height - scaledHeight) / 2;

			htmlContainer.style.position = 'fixed';
			htmlContainer.style.left = `${canvasRect.left}px`;
			htmlContainer.style.top = `${canvasRect.top}px`;
			htmlContainer.style.width = `${this.game.config.width}px`;
			htmlContainer.style.height = `${this.game.config.height}px`;
			htmlContainer.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
			htmlContainer.style.transformOrigin = 'top left';
		};

		syncHTMLContainer();

		const resizeHandler = () => syncHTMLContainer();
		window.addEventListener('resize', resizeHandler);

		const thumbSVG = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 80 180'%3E%3Cdefs%3E%3ClinearGradient id='thumbGrad' x1='0%25' y1='0%25' x2='0%25' y2='100%25'%3E%3Cstop offset='0%25' style='stop-color:%23E8E8FF;stop-opacity:1' /%3E%3Cstop offset='50%25' style='stop-color:%23BECCFF;stop-opacity:1' /%3E%3Cstop offset='100%25' style='stop-color:%23A8A8FF;stop-opacity:1' /%3E%3C/linearGradient%3E%3C/defs%3E%3Crect width='80' height='180' rx='40' fill='url(%23thumbGrad)' stroke='%2311044E' stroke-width='3'/%3E%3Cellipse cx='40' cy='35' rx='30' ry='18' fill='%23ffffff' opacity='0.3'/%3E%3Crect x='25' y='70' width='30' height='4' rx='2' fill='%23ffffff' opacity='0.5'/%3E%3Crect x='25' y='80' width='30' height='4' rx='2' fill='%23ffffff' opacity='0.5'/%3E%3Crect x='25' y='90' width='30' height='4' rx='2' fill='%23ffffff' opacity='0.5'/%3E%3C/svg%3E`;

		// Add custom styles for the custom scrollbar
		const style = document.createElement('style');
		style.id = styleId;
		style.innerHTML = `
        #tutorial-scrollbar-container {
            position: fixed;
            top: 0;
            left: 0;
            width: ${this.game.config.width}px;
            height: ${this.game.config.height}px;
            pointer-events: none;
            z-index: 1000;
        }
        
        .tutorial-scrollbar-wrapper {
            position: absolute;
            left: ${this.game.config.width / 2}px;
            top: ${this.game.config.height * 0.55}px;
            transform: translate(-50%, -50%) scale(${this.scaleFactor});
            transform-origin: center center;
            pointer-events: auto;
            display: flex;
            gap: 20px;
        }
        
        .tutorial-scrollbar-track {
            width: 40px;
            height: 200px;
            background: #5C58EB;
            border-radius: 50px;
            border: 3px solid #11044E;
            position: relative;
            overflow: hidden;
        }
        
        /* Thumb outline at bottom */
        .tutorial-scrollbar-track::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: calc(100% - 8px);
            height: 60px;
            border: 2px dashed rgba(190, 204, 255, 0.5);
            border-radius: 50px;
            pointer-events: none;
        }
        
        .tutorial-scrollbar-thumb {
            width: 100%;
            height: 60px;
            background-image: url("${thumbSVG}");
            background-size: cover;
            background-position: center;
            border-radius: 50px;
            box-shadow: 0 0 10px rgba(168, 168, 255, 0.5);
            position: absolute;
            top: 0;
            cursor: pointer;
            transition: box-shadow 0.3s ease;
			-webkit-touch-callout: none;
    		-webkit-user-select: none;
    		user-select: none;
    		touch-action: none;
        }
        
        .tutorial-scrollbar-thumb.dragging {
            transition: none;
        }
        
        .tutorial-scrollbar-thumb.at-bottom {
            box-shadow: 0 0 20px rgba(144, 238, 144, 0.8);
        }
    `;
		document.head.appendChild(style);

		// Create custom scrollbar HTML
		const scrollbarHTML = `
        <div class="tutorial-scrollbar-wrapper">
            <div class="tutorial-scrollbar-track">
                <div class="tutorial-scrollbar-thumb" id="scrollbar-thumb"></div>
            </div>
        </div>
    `;

		htmlContainer.innerHTML = scrollbarHTML;

		// Add drag functionality
		const thumb = document.getElementById('scrollbar-thumb');
		const track = thumb.parentElement;
		let isDragging = false;
		let startY = 0;
		let startTop = 0;
		let hasReachedBottom = false;

		const checkIfAtBottom = () => {
			const maxTop = track.offsetHeight - thumb.offsetHeight;
			const currentTop = thumb.offsetTop;
			const threshold = 5; // pixels of tolerance

			if (currentTop >= maxTop - threshold && !hasReachedBottom) {
				hasReachedBottom = true;
				thumb.classList.add('at-bottom');

				// Advance to next step after a short delay
				setTimeout(() => {
					this.cleanupScrollbar(htmlContainer, styleId, resizeHandler);
					this.wellDoneAnimation(() => this.tutorialStep05());
					if (this.scrollTutImage) {
						this.scrollTutImage.destroy()
					}
					if (this.scrollAnim) {
						this.scrollAnim.destroy()
					}
				}, 500);
			}
		};

		thumb.addEventListener('mousedown', (e) => {
			isDragging = true;
			startY = e.clientY;
			startTop = thumb.offsetTop;
			thumb.classList.add('dragging');
			e.preventDefault();
		});

		document.addEventListener('mousemove', (e) => {
			if (!isDragging) return;

			const deltaY = e.clientY - startY;
			let newTop = startTop + deltaY;

			// Constrain within track
			const maxTop = track.offsetHeight - thumb.offsetHeight;
			newTop = Math.max(0, Math.min(newTop, maxTop));

			thumb.style.top = newTop + 'px';
			checkIfAtBottom();
		});

		document.addEventListener('mouseup', () => {
			if (isDragging) {
				isDragging = false;
				thumb.classList.remove('dragging');
			}
		});

		// Touch support for mobile
		thumb.addEventListener('touchstart', (e) => {
			isDragging = true;
			startY = e.touches[0].clientY;
			startTop = thumb.offsetTop;
			thumb.classList.add('dragging');
			e.preventDefault();
		});

		document.addEventListener('touchmove', (e) => {
			if (!isDragging) return;

			const deltaY = e.touches[0].clientY - startY;
			let newTop = startTop + deltaY;

			const maxTop = track.offsetHeight - thumb.offsetHeight;
			newTop = Math.max(0, Math.min(newTop, maxTop));

			thumb.style.top = newTop + 'px';
			checkIfAtBottom();
		});

		document.addEventListener('touchend', () => {
			if (isDragging) {
				isDragging = false;
				thumb.classList.remove('dragging');
			}
		});

		// Store reference for cleanup
		this.currentScrollbar = htmlContainer;
		this.scrollbarResizeHandler = resizeHandler;

		if (!this.anims.exists('scrollAnim')) {
			this.anims.create({
				key: 'scrollAnim',
				frames: this.anims.generateFrameNames('scrollIndicator', {
					prefix: 'scrollIndicator_',
					start: 1,
					end: 75,
					zeroPad: 3,
					suffix: '.png'
				}),
				frameRate: 30,
				repeat: -1
			});
		}

		this.scrollAnim = this.add.sprite(
			this.gameW / 2 + 150 * this.scaleFactor,
			190 * this.scaleFactor,
			'scrollIndicator',
			'scrollIndicator_001.png'
		)
			.setOrigin(0.5)
			.setScale(this.scaleFactor)

		this.scrollAnim.play('scrollAnim')

		this.scrollTutImage = this.add.image(
			this.gameW / 2,
			this.gameH - 35 * this.scaleFactor,
			'scrollTut'
		).setOrigin(0.5).setScale(this.scaleFactor / 3)

		animateElements([this.scrollTutImage], this)
	}
	cleanupScrollbar(container, styleId, resizeHandler) {
		// Remove scrollbar content
		if (container) {
			container.innerHTML = '';
		}

		// Remove styles
		const style = document.getElementById(styleId);
		if (style) {
			style.remove();
		}

		// Remove resize listener
		if (resizeHandler) {
			window.removeEventListener('resize', resizeHandler);
		}
	}

	tutorialStep05() {

		destroyInstructions(this)

		let closeTutHolder = this.add.image(this.gameW / 2, this.gameH / 2, 'closeTutorialHolder').setScale(this.scaleFactor * 0.5)
		let closeButton = this.add.image(closeTutHolder.x + 260 * this.scaleFactor, closeTutHolder.y / 2 + 30 * this.scaleFactor, 'closeTutorialButton').setScale(this.scaleFactor * 0.4)

		let text01 = this.add.text(closeTutHolder.x / 2 + 220 * this.scaleFactor, closeTutHolder.y / 2 + 90 * this.scaleFactor, "Almost There!", {
			fontSize: Math.round(this.fontSize - 2 * this.scaleFactor) + "px",
			fill: "#11044E",
			align: "center",
			fontFamily: '"Gluten", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		})
			.setOrigin(0.5)
			.setDepth(2)

		let text02 = this.add.text(closeTutHolder.x / 2 + 220 * this.scaleFactor, closeTutHolder.y / 2 + 120 * this.scaleFactor,
			"Press the ‘X’ Close button to finish the test", {
			fontSize: Math.round(this.fontSize - 6 * this.scaleFactor) + "px",
			fill: "#11044E",
			align: "center",
			fontFamily: '"Space Grotesk", sans-serif',
			fontStyle: "bold",
			fontWeight: "200",
			resolution: 2,
			wordWrap: { width: closeTutHolder.width * this.scaleFactor * 0.8 },
		})
			.setOrigin(0.5)
			.setDepth(2)

		closeButton.setInteractive()
		closeButton.on('pointerdown', () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.wellDoneAnimation(() => this.tutorialStep06());
			closeTutHolder.destroy()
			closeButton.destroy()
			text01.destroy()
			text02.destroy()
		})
	}

	tutorialStep06() {

		let spaceRocket = this.add.image(this.gameW / 2, 80 * this.scaleFactor, 'spaceMedal').setScale(this.scaleFactor * 0.5)
		let whatsMyMissionHolder = this.add.image(this.gameW / 2, this.gameH / 2 + 1 * this.scaleFactor, 'whatsMyMissionHolder').setScale(this.scaleFactor * 0.5).setOrigin(0.5)
		let whatsMyMissionButton = this.add.image(this.gameW / 2, this.gameH - 80 * this.scaleFactor, 'whatsMyMissionButton').setScale(this.scaleFactor * 0.5).setInteractive()

		let text01 = this.add.text(whatsMyMissionHolder.x, whatsMyMissionHolder.y - 25 * this.scaleFactor, "You Did It!!", {
			fontSize: Math.round(this.fontSize - 2 * this.scaleFactor) + "px",
			fill: "#11044E",
			align: "center",
			fontFamily: '"Gluten", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		})
			.setOrigin(0.5)
			.setDepth(2)

		let text02 = this.add.text(whatsMyMissionHolder.x, whatsMyMissionHolder.y + 5 * this.scaleFactor,
			"You are ready for your first mission!\nPress the button below to continue.", {
			fontSize: Math.round(this.fontSize - 8 * this.scaleFactor) + "px",
			fill: "#11044E",
			align: "center",
			fontFamily: '"Space Grotesk", sans-serif',
			fontStyle: "bold",
			fontWeight: "200",
			resolution: 2,
			//wordWrap: { width: whatsMyMissionHolder.width * this.scaleFactor * 0.8 },
		})
			.setOrigin(0.5)
			.setDepth(2)

		let buttonText = this.add.text(whatsMyMissionButton.x, whatsMyMissionButton.y - 10 * this.scaleFactor, "WHAT IS MY MISSION?", {
			fontSize: Math.round(this.fontSize + 11 * this.scaleFactor) + "px",
			fill: "#FFFFFF",
			align: "center",
			fontFamily: '"Gluten", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		})
			.setOrigin(0.5)
			.setDepth(2)

		whatsMyMissionButton.on('pointerdown', () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			//this.scene.start('Customization')
			this.intro01()
			spaceRocket.destroy()
			whatsMyMissionHolder.destroy()
			whatsMyMissionButton.destroy()
			text01.destroy()
			text02.destroy()
			buttonText.destroy()
		})
	}

	intro01() {

		displayInstructions(this, "", 12, 400, 70)
		this.instroHeaderText = this.add.text(
			this.gameW / 2,
			8 * this.scaleFactor + 14 * this.scaleFactor,
			"Your Mission", {
			fontSize: Math.round(this.fontSize - 2 * this.scaleFactor) + "px",
			fill: "#11044E",
			align: "center",
			fontFamily: '"Gluten", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		}).setDepth(3).setOrigin(0.5)
		this.instroText = this.add.text(
			this.safeZoneX + this.safeZoneWidth / 2,
			8 * this.scaleFactor + 35 * this.scaleFactor,
			"As a Medinaut you will have to", {
			fontSize: Math.round(this.fontSize - 5 * this.scaleFactor) + "px",
			fill: "#11044E",
			align: "center",
			fontFamily: '"Space Grotesk", sans-serif',
			//fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		}).setDepth(3).setOrigin(0.5)
		let currentPage = 0
		let introImage = this.add.image(this.gameW / 2, this.gameH / 2, 'missionHolder01').setScale(this.scaleFactor * 0.5)
		let nextButton = this.add.image(this.gameW / 2 + 150 * this.scaleFactor, this.gameH - 50 * this.scaleFactor, 'forwardButton').setScale(this.scaleFactor * 0.5).setInteractive()
		let nextButtonText = this.add.text(nextButton.x, nextButton.y - 7 * this.scaleFactor, "NEXT", {
			fontSize: Math.round(this.fontSize + 11 * this.scaleFactor) + "px",
			fill: "#FFFFFF",
			align: "center",
			fontFamily: '"Gluten", sans-serif',
			fontStyle: "bold",
			fontWeight: "700",
			resolution: 2,
		})
			.setOrigin(0.5)
			.setDepth(2)
			.setVisible(false)
		let backButton = this.add.image(this.gameW / 2 - 150 * this.scaleFactor, this.gameH - 50 * this.scaleFactor, 'backButton').setScale(this.scaleFactor * 0.5).setInteractive().setVisible(false)

		let pageIndicators = []
		for (let i = 0; i < 3; i++) {
			let indicator = this.add.image(this.gameW / 2 - 30 * this.scaleFactor + i * 30 * this.scaleFactor, this.gameH - 50 * this.scaleFactor, i === 0 ? 'activePageIndicator' : 'inactivePageIndicator').setScale(this.scaleFactor * 0.5)
			pageIndicators.push(indicator)
		}

		displayTutorialHand(this, {
			xPos: nextButton.x - 75 * this.scaleFactor,
			yPos: nextButton.y - 55 * this.scaleFactor,
			rotation: 120
		})

		nextButton.on('pointerdown', () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			// Disable the button to prevent multiple clicks
			nextButton.disableInteractive();

			if (currentPage == 0) {
				introImage.setTexture('missionHolder02')
				backButton.setVisible(true)
				pageIndicators[0].setTexture('inactivePageIndicator')
				pageIndicators[1].setTexture('activePageIndicator')
			}
			else if (currentPage == 1) {
				introImage.setTexture('missionHolder03')
				pageIndicators[1].setTexture('inactivePageIndicator')
				pageIndicators[2].setTexture('activePageIndicator')
				nextButton.setTexture("normalWideBtn")
				nextButtonText.setVisible(true)
			}
			else if (currentPage == 2) {
				this.wellDoneOverlay.remove()
				this.wellDoneTextEl.remove()
				this.scene.start('Customization')
				return; // Exit early, no need to re-enable
			}

			currentPage++

			// Re-enable the button after a short delay (e.g., 300ms)
			this.time.delayedCall(300, () => {
				nextButton.setInteractive();
			});
		})

		backButton.on('pointerdown', () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			backButton.disableInteractive();

			if (currentPage == 1) {
				introImage.setTexture('missionHolder01')
				backButton.setVisible(false)
				pageIndicators[0].setTexture('activePageIndicator')
				pageIndicators[1].setTexture('inactivePageIndicator')
			}
			else if (currentPage == 2) {
				introImage.setTexture('missionHolder02')
				pageIndicators[1].setTexture('activePageIndicator')
				pageIndicators[2].setTexture('inactivePageIndicator')
				nextButton.setTexture("forwardButton")
				nextButtonText.setVisible(false)
			}
			currentPage--

			this.time.delayedCall(300, () => {
				backButton.setInteractive();
			})
		})
	}

	cleanupScrollbar(container, styleId) {
		if (container && container.parentNode) {
			container.remove();
		}
		const style = document.getElementById(styleId);
		if (style) {
			style.remove();
		}
	}

	createBackground() {
		// Add background
		this.add
			.image(this.gameW / 2, this.gameH / 2, "spaceBG")
			.setScale(this.scaleFactor * 0.5)
	}

	createStoryBackground() {
		this.storyBG = this.add
			.image(this.gameW / 2, this.gameH / 2, "wideContainer")
			.setOrigin(0.5)
			.setScale(this.scaleFactor * 1, this.scaleFactor * 1.2)
	}

	createPageIndicators() {
		const xOffset = 25 * this.scaleFactor
		const yOffset = 70 * this.scaleFactor
		// Page indicators
		this.pageIndicator01 = this.add
			.image(
				this.storyBG.x - xOffset,
				this.storyBG.y + yOffset,
				"activePageIndicator",
			)
			.setScale(this.scaleFactor * 0.65)

		this.pageIndicator02 = this.add
			.image(this.storyBG.x, this.storyBG.y + yOffset, "inactivePageIndicator")
			.setScale(this.scaleFactor * 0.65)

		this.pageIndicator02 = this.add
			.image(
				this.storyBG.x + xOffset,
				this.storyBG.y + yOffset,
				"inactivePageIndicator",
			)
			.setScale(this.scaleFactor * 0.65)
	}

	createWelcomeScreen() {
		const xOffset = 50 * this.scaleFactor
		this.welcomeTitle = this.add
			.text(
				this.storyBG.x - (this.storyBG.width / 2) * this.scaleFactor + xOffset,
				this.storyBG.y - 100 * this.scaleFactor,
				"Welcome to C.A.R.E.",
				{
					fontSize: Math.round(this.fontSize + 12 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "600",
					fontStyle: "bold",
					resolution: 2,
					align: "left",
				},
			)
			.setOrigin(0, 0.5)
		this.firstContainer.add(this.welcomeTitle)

		// First paragraph
		this.welcomeText = this.add
			.text(
				this.storyBG.x - (this.storyBG.width / 2) * this.scaleFactor + xOffset,
				this.welcomeTitle.y + 30 * this.scaleFactor,
				"The Cosmic Alliance for Recovery & Exploration",
				{
					fontSize: Math.round(this.fontSize - 3 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
					align: "left",
				},
			)
			.setOrigin(0, 0.5)
		this.firstContainer.add(this.welcomeText)

		// Second paragraph
		this.welcomeText02 = this.add
			.text(
				this.storyBG.x - (this.storyBG.width / 2) * this.scaleFactor + xOffset,
				this.welcomeText.y + 70 * this.scaleFactor,
				"Congratulations, Medinaut! You’ve officially been recruited to the galaxy’s most heartwarming team of health and science officers known as C.A.R.E. — the Cosmic Alliance for Recovery & Exploration.\n\nOur mission? To bring care, curiosity, and compassion to the farthest corners of the galaxy.",
				{
					fontSize: Math.round(this.fontSize - 3 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "700",
					resolution: 2,
					align: "left",
					wordWrap: { width: this.safeZoneWidth * 0.6 },
				},
			)
			.setOrigin(0, 0.5)
		this.firstContainer.add(this.welcomeText02)
	}

	shutdown() {
		// Clean up DOM elements when scene shuts down
		if (this.wellDoneOverlay && this.wellDoneOverlay.parentNode) {
			this.wellDoneOverlay.remove();
		}

		// Clean up tutorial checkbox
		const tutorialStep = document.getElementById('tutorial-step-01');
		if (tutorialStep) {
			tutorialStep.remove();
		}

		// Clean up dropdown
		const dropdownContainer = document.getElementById('tutorial-dropdown-container');
		if (dropdownContainer) {
			dropdownContainer.remove();
		}

		// Clean up scrollbar
		const scrollbarContainer = document.getElementById('tutorial-scrollbar-container');
		if (scrollbarContainer) {
			scrollbarContainer.remove();
		}

		// Clean up any tutorial styles
		const styles = ['tutorial-checkbox-styles', 'tutorial-dropdown-styles', 'tutorial-scrollbar-styles'];
		styles.forEach(styleId => {
			const style = document.getElementById(styleId);
			if (style) {
				style.remove();
			}
		});

		// Remove any event listeners
		if (this.dropdownResizeHandler) {
			window.removeEventListener('resize', this.dropdownResizeHandler);
		}
		if (this.scrollbarResizeHandler) {
			window.removeEventListener('resize', this.scrollbarResizeHandler);
		}

		// Remove the entire container, not just its contents
		if (container && container.parentNode) {
			container.remove(); // ← Changed from innerHTML = ''
		}

		// Remove styles
		// const style = document.getElementById(this.styleId);
		// if (style) {
		// 	style.remove();
		// }

		// Remove resize listener
		if (resizeHandler) {
			window.removeEventListener('resize', resizeHandler);
		}
	}

	wellDoneAnimation(passFunction) {
		// Pick a random phrase that's different from the last one
		let randomPhrase;
		do {
			randomPhrase = this.congratsPhrases[Math.floor(Math.random() * this.congratsPhrases.length)];
		} while (randomPhrase === this.lastCongratsPhrase && this.congratsPhrases.length > 1);

		// Update the last phrase used
		this.lastCongratsPhrase = randomPhrase;
		this.wellDoneTextEl.textContent = randomPhrase;

		// Slide in from right
		this.wellDoneOverlay.style.transform = 'translateX(0%)';

		setTimeout(() => {
			if (passFunction) {
				passFunction();
			}

			// Wait 2 seconds, then slide out to the left
			setTimeout(() => {
				this.wellDoneOverlay.style.transform = 'translateX(-100%)';

				// Reset position after animation completes
				setTimeout(() => {
					this.wellDoneOverlay.style.transition = 'none';
					this.wellDoneOverlay.style.transform = 'translateX(100%)';

					// Re-enable transition for next animation
					setTimeout(() => {
						this.wellDoneOverlay.style.transition = 'transform 0.5s ease';
					}, 50);
				}, 500);
			}, 1000);
		}, 1000);
	}
}
